module.exports = __webpack_public_path__ + "img/redcircle.08120a7e.svg";